// removed by extract-text-webpack-plugin
module.exports = {"Loader":"styles__Loader___1Upx4","loader10":"styles__loader10___3rQjD","Logo":"styles__Logo___2XJWp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Main/Loader/styles.scss
// module id = 1302
// module chunks = 0